import PropTypes from 'prop-types'
import React from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { connect } from 'react-redux'
import Selectors from '../../../../selectors'
import { history } from '../../../../store'
import { withRouter } from '../../../../withRouter'

function DefaultRedirect(props) {
  React.useEffect(() => {
    handleRedirect(props)
  })
  return null
}

function handleRedirect(props) {
  const {
    listId,
    selectedItem,
    router,
    location: { prev }
  } = props

  const isMobile = !isBrowser && !isTablet
  if (router.params.id || isMobile) return
  const route = `/${listId}`
  const pattern = new RegExp(`${route}/.*`, 'i')
  if (prev && prev.match(pattern) && !prev.match(/edit$/)) {
    history.back()
    return
  }

  if (prev === `/${listId}`) return
  if (selectedItem) {
    history.push(`/${listId}/${selectedItem}/profile`)
  }
}

DefaultRedirect.propTypes = {
  selectedItem: PropTypes.string
}

const mapStateToProps = (state, props) => {
  return {
    selectedItem: Selectors.selectFirstItem(state, { listId: 'homes' }),
    id: props.router.params.id,
    location: state.global.location
  }
}

export default withRouter(connect(mapStateToProps, null)(DefaultRedirect))
